import storeConnector from '@src/store/storeConnector';
import { SiteMeta } from '@src/types/SiteMeta';
import siteMeta from '@src/utils/defaultDataStubs/siteMeta';
import { Navigate, useLocation } from 'react-router';

function ConfigBetaGuard({
  children,
}: { siteMeta: SiteMeta; children: React.ReactNode }) {
  const location = useLocation();
  const isBetaEnabled = siteMeta?.ui?.features?.Modes_V3_Beta;

  if (!isBetaEnabled && location.pathname.includes('/config-beta')) {
    const redirectPath = location.pathname.replace('/config-beta', '/config');
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
}

export default storeConnector(ConfigBetaGuard, {
  config: ['siteMeta'],
});
